// Pill-shaped selectable chip. Used across onboarding (cuisine, diet,
// allergens, dislikes) and filters in the meals tab.
//
// Props:
//   label    — visible text
//   selected — boolean; styles the chip as active
//   onClick  — click handler
//   emoji    — optional leading emoji
//   color    — optional override accent color (defaults to brand green)

import { C } from "../theme.js";

export function Chip({ label, selected, onClick, emoji, color, role, "aria-checked": ariaChecked, "aria-pressed": ariaPressed }) {
  return (
    <button
      onClick={onClick}
      role={role}
      aria-checked={ariaChecked}
      aria-pressed={ariaPressed}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: "9px 15px", borderRadius: 99,
        border: `1.5px solid ${selected ? (color || C.green) : C.border}`,
        background: selected ? (color ? `${color}18` : C.greenPale) : C.white,
        color: selected ? (color || C.green) : C.charcoal,
        fontWeight: 600, fontSize: 14, cursor: "pointer",
        transition: "all .18s",
        boxShadow: selected ? C.sh : "none",
        // Bulletproof against parent flex containers: never shrink or wrap.
        // Without this, chips inside `display:flex` with overflow can collapse
        // to padding-only, hiding the label and rendering as a colored dot.
        flexShrink: 0,
        whiteSpace: "nowrap",
      }}
    >
      {emoji && <span>{emoji}</span>}
      {label}
    </button>
  );
}
